import { render, staticRenderFns } from "./eventTicketListPage.vue?vue&type=template&id=006c70ea&"
import script from "./eventTicketListPage.vue?vue&type=script&lang=ts&"
export * from "./eventTicketListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports